module.exports = __webpack_public_path__ + "img/1YMJlsuDgP9E2jvFrFXWcR5SvshyO2jhA.bab39ce4.jpg";